export default "__VITE_ASSET__CITwrObj__"